import { useState } from 'react';
import { galleryImages } from '@/mocks/gallery';

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-primary-500 font-label text-sm tracking-[0.15em] uppercase mb-3">
            Visual Journey
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
            Gallery
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-base">
            A glimpse into the Ghalib Chai experience — from our golden brews
            to the cozy moments we create.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {galleryImages.map((image, index) => (
            <button
              key={image.id}
              onClick={() => setSelectedImage(image.src)}
              className={`relative overflow-hidden rounded-lg group cursor-pointer ${
                index === 0 || index === 5
                  ? 'col-span-2 row-span-2 aspect-square md:aspect-auto'
                  : 'aspect-square'
              }`}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-foreground-950/0 group-hover:bg-foreground-950/30 transition-colors duration-300 flex items-end p-4">
                <span className="text-background-50 text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {image.category}
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 z-[100] bg-foreground-950/90 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-background-50 hover:text-accent-400 transition-colors z-10"
            onClick={() => setSelectedImage(null)}
            aria-label="Close gallery"
          >
            <i className="ri-close-line text-3xl" />
          </button>
          <img
            src={selectedImage}
            alt="Gallery preview"
            className="max-w-full max-h-[85vh] rounded-lg object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}